import { FC } from 'react'

import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { TaskInput } from './types'
import { useQuoteData } from '../../hooks/useQuoteData'
import { NotificationHeader } from '../../components/NotificationHeader'

export const QuoteStuckInPreparingSignatureRequestStatusHeader: FC<{
  taskId: string
}> = ({ taskId }) => {
  const { manualTask } = useManualTask({ taskId })
  const { quote, customer } = useQuoteData(
    (manualTask?.input as TaskInput | undefined)?.quoteId
  )

  return (
    <NotificationHeader
      data-testid="watchtower.notification.quoteStuckInPreparingSignatureRequestStatus.header"
      customer={customer}
      identifier={quote?.quoteNumber}
      title={
        quote ? `${quote.title} Stuck preparing signature requests` : undefined
      }
    />
  )
}
